import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export function useCollection(name, params) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});

  const reload = useCallback(async () => {
    if (params === null) return setItems([]);
    try {
      const { data } = await api.get(`/${name}`, { params: JSON.parse(key) });
      setItems(data);
    } catch {
      setItems([]);
    }
    setLoading(false);
  }, [name, key]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { reload(); }, [reload]);

  const run = async (fn, msg) => {
    try {
      const { data } = await fn();
      await reload();
      if (msg) toast.success(msg);
      return data;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return {
    items, loading, reload,
    create: (body, msg = "Saved") => run(() => api.post(`/${name}`, body), msg),
    update: (id, body, msg = "Updated") => run(() => api.patch(`/${name}/${id}`, body), msg),
    remove: (id, msg = "Deleted") => run(() => api.delete(`/${name}/${id}`), msg),
  };
}
